import { useState, useCallback } from 'react';
import emailValidator from 'email-validator';

const useEmailValidation = (errorMessage) => {
  const [emailValue, setEmailValue] = useState('');
  const [emailInvalidErrMsg, setEmailInvalidErrMsg] = useState('');

  const validateEmail = useCallback(() => {
    const isValid = emailValidator.validate(emailValue);
    if (!isValid) {
      setEmailInvalidErrMsg(errorMessage);
    }
    return isValid;
  }, [emailValue, errorMessage]);

  const handleEmailChange = useCallback((e) => {
    setEmailValue(e.target.value);
    if (emailInvalidErrMsg) setEmailInvalidErrMsg('');
  }, [emailInvalidErrMsg]);

  const handleEmailBlur = useCallback(() => {
    if (emailValue.trim()) {
      validateEmail();
    }
  }, [emailValue, validateEmail]);

  const resetEmail = useCallback(() => {
    setEmailValue('');
    setEmailInvalidErrMsg('');
  }, []);

  const setEmail = useCallback((email) => {
    setEmailValue(email);
  }, []);

  return {
    emailValue,
    emailInvalidErrMsg,
    validateEmail,
    handleEmailChange,
    handleEmailBlur,
    resetEmail,
    setEmail,
  };
};

export default useEmailValidation;
